<script>
  import RadioButton from '@itslearning/prometheus/assets/inputs/RadioButton/v1/RadioButton.svelte';
  import {questionAnswers} from '../../stores';

  export let question = { };
  export let questionAnswer = null;
  export let readonly = false;

  /**
   * set true if you do not want answer to be displayed, useful when e.g. printing survey
   * @type {boolean}
   */
  export let hideAnswer = false;

  function select(matrixRowId, alternativeId) {
    if (hideAnswer) {
      return;
    }
    if (!answer.matrixAnswers) {
      answer.matrixAnswers = [];
    }
    let matrixAns = answer.matrixAnswers.find(r => r.matrixRowId === matrixRowId);
    if (matrixAns) {
      matrixAns.alternativeIds = [alternativeId];
    } 
    else {
      answer.matrixAnswers.push({matrixRowId: matrixRowId, alternativeIds: [alternativeId]});
    }
  }

  function getSelected(answer, matrixRowId) {
    if (hideAnswer) {
      return 0;
    }
    if (answer && answer.matrixAnswers) {
      const a = answer.matrixAnswers.find(a => a.matrixRowId === matrixRowId);
      if (a && a.alternativeIds && a.alternativeIds.length > 0) {
        return a.alternativeIds[0];
      }
    }
    return 0;
  }

  $: answer = questionAnswer ? questionAnswer : $questionAnswers.find(a => a.questionId === question.questionId);
  $: forceListView = question && question.alternatives && question.alternatives.length > 5;
</script>

<div class="{forceListView ? 'matrix-list' : 'matrix'}">

  {#if !forceListView}
    <div class="row matrix-header" aria-hidden="true">
      <div class="cell statement"></div>
      <ul>
        {#each question.alternatives as alternative}
          <!-- these texts should not be read by screen readers, they are already connected to the radio button labels -->
          <li class="cell">{alternative.text}</li>
        {/each}
      </ul>
    </div>
  {/if}

  {#each question.matrixRows as row, i}
    <div class={i % 2 === 0 ? 'row alternate' : 'row'}>
      <h3 class="cell statement row-title" id={'lbl_R' + row.matrixRowId}>
        {row.text}
      </h3>
      <ul role="radiogroup" aria-labelledby={'lbl_R' + row.matrixRowId}>
        {#each question.alternatives as alternative}
          <li class="cell">
            <RadioButton
              label={alternative.text}
              id={'R' + row.matrixRowId + 'C' + alternative.alternativeId}
              name={'R' + row.matrixRowId}
              value={alternative.alternativeId}
              small={true}
              selected={getSelected(answer, row.matrixRowId)}
              disabled={readonly}
              on:selected={() => select(row.matrixRowId, alternative.alternativeId)}
              >
            </RadioButton>
          </li>
        {/each}
      </ul>
    </div>
  {/each}

</div>

